<template>
  <div class="content">
    <div class="container-fluid">
      <b-navbar type="light" variant="light" sticky>
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>
          <b-nav-text>{{account.name}} - {{company.name}}</b-nav-text>
          <!-- Navbar dropdowns -->
          <b-nav-item-dropdown text="Actions" left v-if="isAdmin()">
            <b-dropdown-item @click="changeCompany()"><b-icon icon="building" variant="primary"></b-icon> Changer la fiche signalétique du compte</b-dropdown-item>
            <b-dropdown-item @click="deleteWithConfirm('')"><b-icon icon="dash-circle" variant="danger"></b-icon> Supprimer</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
      
      <div class="row">
<!-- https://demos.creative-tim.com/light-bootstrap-dashboard-pro/examples/components/icons.html -->
        <div class="col-xl-4 col-md-6">
          <stats-card :style="getCardStyle(this.account._status)"><!-- A. Votre compte -->
            <div slot="content">
              <h4 class="card-title"><status-icon :status="this.account._status" /> <label-editable resourcekey="ppe_home_account_title" text="A. Votre compte"/></h4>
              <p class="card-category">{{account.name}}</p>
              <p class="card-category">{{account.email}}</p>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i> {{toDate(this.account._modified)}}
              <!-- <router-link :to="'/ppe_ee/account/'+(this.account.id)+'?'+getRedirectUrl()" active-class="active" class="navbar-brand">Modifier</router-link> -->
              <router-link :to="urlWithRedirect('/ppe_ee/account/'+(this.account.id))" active-class="active" >Modifier</router-link>
            </div>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card :style="getCardStyle(this.company._status)"> <!-- B1. Fiche signalétique : celle d'AKC-->
            <div slot="content">
              <h4 class="card-title"><status-icon :status="this.company._status" /> <label-editable resourcekey="ppe_home_signaletic_title" text="B1. Fiche signalétique"/></h4>
              <p class="card-category">{{company.name}}</p>
              <p class="card-category">{{company.address}} {{company.zip}} {{company.city}}</p>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i> {{toDate(this.company._modified)}}
              <router-link :to="urlWithRedirect('/ppe_ee/company_ee/'+(this.company.id))" active-class="active" >Modifier</router-link>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card :style="getCardStyle()"> <!-- Aide-->
            <div slot="content">
              <h4 class="card-title"><label-editable resourcekey="ppe_home_help_title" text="Plan de Prévention Evolutif"/></h4>
              <p class="card-category"><label-editable resourcekey="ppe_home_help_subtitle" text="Pour quoi faire ?"/></p>
              <p class="card-category"></p>
            </div>
            <div slot="footer">
              <i class="fa fa-external-link"></i> 
              <a color="primary" class="active" href="#" @click="displayHelp()"><label-editable resourcekey="ppe_home_help_link" text="En savoir plus" /></a>
            </div>
          </stats-card>
        </div>

      </div>

      <div class="row" v-if="!canDisplayOperations()">
        <div class="col-xl-12 col-md-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title"><label-editable resourcekey="ppe_home_operation_list" text="Opérations en cours"></label-editable></h4>
              <p class="card-category"><label-editable resourcekey="ppe_home_operation_not_ready" text="Veuillez compléter votre compte et votre fiche de présentation avant de vous inscrire sur une nouvelle opération"></label-editable></p>
            </template>
          </card>
        </div>
      </div>


      <div class="row"  v-if="canDisplayOperations()">
        <div class="col-xl-12 col-md-12">

          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title"><label-editable resourcekey="ppe_home_operations_title" text="Opérations en cours"/></h4>
              <p class="card-category"><label-editable resourcekey="ppe_home_operations_subtitle" text="Liste des opérations sur lesquelles vous intervenez"/></p>
            </template>
            <h5 v-if="!hasSubscribedOperations()"><label-editable resourcekey="ppe_home_operations_empty" text="Vous n'intervenez sur aucune opération encore."/></h5>
            <b-table responsive striped hover :items="subscribedOperations" :fields="subscribedOperationscolumns" v-if="hasSubscribedOperations()">
              <!-- A virtual column --> 
              <template #cell(_status)="row">
                <b><status-icon :status="row.item._status" /></b>
              </template>
              <template #cell(id)="row">
                <router-link :to="urlWithRedirect('/ppe_ee/operation_home_ee/'+row.item.id)"><label-editable resourcekey="ppe_home_operations_open" text="Ouvrir"/></router-link>
              </template>
              <template #cell(operation.startDate)="row">
                <span style="white-space:nowrap">{{toDate(row.item['operation.startDate'])}}</span>
              </template>
              <template #cell(operationtype)="row">
                {{typeToText(row.item['operation.type'])}}
              </template>
            </b-table>
            <div class="col-xl-12 col-md-12">
              <div class="row">
                <h4>S'inscrire sur une nouvelle opération</h4>
              </div>
              <div class="row">
                <div data-classification="text" data-type="text" class="formulate-input col-3" data-has-value="true">
                  <div class="formulate-input-wrapper">
                    <label for="operationCode" class="formulate-input-label formulate-input-label--before"
                      >Entrez le code de l'opération</label> 
                    <div data-type="text" class="formulate-input-element formulate-input-element--text">
                      <input type="text" placeholder="" id="operationCode" v-model="operationCode"> 
                    </div> 
                  </div>
                </div>
                <div class="col-md-6">
                  <div>&nbsp;</div>
                    <button class="btn btn-default" :disabled="!operationCode" v-on:click="doSubscribeTo('clic')">S'enregistrer sur cette opération</button>
                </div>
              </div>
              <div class="row">
                  <div class="col-12">Ce code vous a été communiqué par votre donneur d'ordre</div>
              </div>  
            </div>
          </card>
        </div>
      </div>
      


    </div>
  <ChangeCompany ref="changeCompany" />

  </div>

  

</template>
<style>
.help_dialog {
  width: 66%;
  text-align: left;
}


</style>
<script>
  //import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from '../../components/Cards/StatsCard.vue'
  //import LTable from 'src/components/Table.vue'
  import StatusIcon from '../../components/StatusIcon.vue'
  import swal from 'sweetalert'
  const Business = require('ppe-business')
  import common from '../common/pages.js'
  import ChangeCompany from '../../components/Dialogs/ChangeCompany.vue'


  export default {
    components: {
      StatsCard,
      StatusIcon,
      ChangeCompany
    },


    mounted() {
      this.$http.get(this.getApiUrl())
        .then(response => {
          console.log("PPEHome:"+this.getApiUrl(), response.data)
					this.operations           = response.data.operations
          this.company              = response.data.company
          this.account              = response.data.account
          this.subscribedOperations = response.data.operations_subscribed

          this.$refs.changeCompany.init(this.company, this.account)
          } )
        .catch( (err, res) => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
          //console.error("PPEHome.vue:res", err.response)
					
          //console.error("PPEHome.vue:mounted", JSON.stringify(error))
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
          
          //if(error.status === 401)
          //   router().replace("/login?redirect="+error.config.url)
        })
    },


    data () {
      return {
        operationCode:'',
        account:{},
        company:{},
        operations: [],
        subscribedOperations: [],

        //selectedCompany: null,  // store selected company
        //companySearchQuery: '',
        //companySuggestions: [],        

        columns: [
          {key:'_status',label:'Etat'}, 
          {key:'code',label:'Code'}, 
          {key:'type', label:'Type'},
          {key:'operationname', label:'Opération'},
          {key:'sitename',label:'Site'}, 
          {key:'startDate', label:'Début'},
          {key:'id', label:'Action'},
          ],

        subscribedOperationscolumns: [
          {key:'_status',label:'Etat'}, 
          {key:'operation.code',label:'Code'}, 
          {key:'operationtype', label:'Type'},
          {key:'operation.operationname', label:'Opération'},
          {key:'operation.sitename',label:'Site'}, 
          {key:'operation.startDate', label:'Début'},
          {key:'id', label:'Action'},
          ],
      }
    },

    methods:{
      ...common.methods,

      /**
       * "2022-02-12T23:45:41.452Z" => 12/fev/2022
       */
      toDate(apiDate) { 
        //console.log("apiDate", apiDate)
        return Business.toDate(apiDate)
        // remove the T in "2022-02-12T23:45:41.452Z" so that is is parsed by Date() constructor
        /*let date = new Date((""+apiDate).replace('T', ' '))
        if(date && date.toShortFormat)
          return date.toShortFormat()
        else
          return apiDate*/
        },

        typeToText(type) {
          return Business.getOperationLabel(type)
        },

       

        getApiUrl() {
          let userId
          console.log('usermanager.getCurrentUser()', this.$usermanager.getCurrentUser())
          if(this.$route.params.id) userId = this.$route.params.id
          else userId = this.$usermanager.getCurrentUser()._id

          return '/ee/dashboard?id='+userId
        },

        canDisplayOperations() {
          return this.hasSubscribedOperations() || Business.canDisplayOperations(this.account._status, this.company._status)
        },

        isHost() {
          return this.company.isHost
        },

        isAdmin() {
          return this.$usermanager.isAdmin()
        },

        hasSubscribedOperations() {
          return this.subscribedOperations && this.subscribedOperations.length > 0
        },

        async doSubscribeTo(element) {
          try {
          let response = await this.$http.get("/ee/operation_subscribe?companyId="+this.company.id+"&code="+this.operationCode)
          let answer;
          console.log("doSubscribeTo:response", response.data)
          if(response.data.code) {


            //alert(this.operationCode)
            answer = await swal({
              title: 'Confirmez ?',
              text: "Vous allez vous inscrire sur l'opération \n" + response.data.code + " " + response.data.operationname,
              type: 'warning',
              buttons: {
                        confirm: "Oui, m'insrire sur cette opération",
                        cancel:  'Non, annuler !',
              },
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
            })
            console.log("answer", answer)

          } else {
            return swal("Erreur", response.data.message, "error");
          }

          if(answer) {
            response = await this.$http.post("/ee/operation_subscribe?companyId="+this.company.id, {code:this.operationCode});
            
            console.log("PPEHome.doSubscribeTo():response.data", response.data)
            this.router().push("/ppe_ee/operation_home_ee/"+response.data.entity['id'])

          } 
          

          } catch(err) {
            swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
          }
    
        },

        async deleteWithConfirm() {
          var answer = await swal({
              title: 'Confirmez ?',
              text: `Vous allez supprimer le compte ${this.account.name} et l'entreprise ${this.company.name} va être retirée des opérations souscrites \n`,
              type: 'warning',
              
              buttons: {
                    cancel:  "Non, annuler",
                    confirm: {text:"Oui, supprimer", className:"btn btn-danger"},
              },
            })
            if(answer) {
              try {
                let response = await this.$http.get("/admin/delete_account?accountid="+this.account.id);
                this.$router.push(this.urlBack())
              } catch(err) {
                swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
              } 
            }
        },

        /*showChangeCompanyDialog() {
          this.$refs.changeCompanyModal.show();
        },
        hideChangeCompanyDialog() {
          this.$refs.changeCompanyModal.hide();
        },

        selectCompany(company) {
          this.selectedCompany = company;
          this.companySearchQuery = `${company.name} (${company.zip} ${company.city})`; // Update the search input with the selected company's name
          this.companySuggestions = [];  // Clear suggestions after select
        },

        async fetchCompanySuggestions(query) {
          
          if (query) {
            try {
              let response = await this.$http.get(`/admin/searchcompanies?host=false&limit=10&q=${query}`);
              this.companySuggestions = response.data.result;  // assuming response.data is an array of company names
            } catch (error) {
              console.error("Error fetching company suggestions:", error);
              swal("Erreur", `Erreur dans la recherche : ${error}`);
            }
          }
        },

        async performChangeCompany() {
          if (this.selectedCompany) {
            try {
              let response = await this.$http.post(`/admin/changecompany`, {accountid:this.account.id, companyid: this.selectedCompany.id });
              await swal("Succès", `La fiche signalétique a été changée par la société ${this.selectedCompany.name}`, "success");
              this.hideChangeCompanyDialog();
              this.$router.go(0);
            } catch (error) {
              swal("Erreur", `Ne peut pas changer la fiche signalétique. ${error.response ? error.response.data : error.message}`, "error");
            }
          } else {
            swal("Erreur", "No company selected", "error");
          }
        },
        */

        async changeCompany() {
          this.$refs.changeCompany.showChangeCompanyDialog();
        },

        displayHelp() {
          var span = document.createElement("span");
          span.className = "small"
          span.innerHTML = "<style> .small > p {font-size:14px;}</style>" + this.$t('ppe_page3_desc') + ""
          
          /*`
              <b>Plan de Prévention Evolutif d’une opération élaboré à partir du Plan de
Prévention matriciel d’une Entreprise Utilisatrice pour gérer l’Intervention
d’Entreprises Extérieures à l’intérieur d’un site / pôle en activité</b><br>

Le Code du travail prévoit un dispositif particulier en organisant les modalités d’interventions d’Entreprises
Extérieures sur le site / dans les locaux d’une Entreprise Utilisatrice (art. R4511 et suivants du Code du
travail).<br>
L’organisation de l’hygiène et de la sécurité lors de l’intervention d’Entreprises Extérieures est prévue par
le décret n°92-158 du 20 février 1992 (art. R4531-1 et suivants du Code du travail).
Ce décret vise à prévenir les risques résultants de l’interférence des activités des Entreprises
Extérieures et de l’Entreprise Utilisatrice.<br>
Il concerne toutes les Prestations, Livraisons, Interventions, Maintenance, Tâches d’amélioration.
Son principe est de gérer l’interactivité et la coactivité des entreprises et de lier la
responsabilité de la sécurité au site/pôle où l’opération se déroule.<br>
La coordination générale des mesures de prévention mise en œuvre par chaque Entreprise Extérieure est
assurée par le chef de l’Entreprise Utilisatrice, chaque chef d’Entreprise Extérieure étant responsable des
mesures de prévention qui protège son propre personnel.<br>
Avant l’exécution de l’opération et sur le site/pôle de l’opération, les chefs d’entreprises procèdent à :
une Visite d’Inspection Préalable des lieux de travail où se déroule l’Opération
une analyse des risques propres, importés, exportés par l’ensemble des entreprises
la mise en place d’un Plan de Prévention Evolutif élaboré par l’Entreprise Utilisatrice à partir de
son plan de Prévention matriciel, complété par les risques liés à l’Opération et les risques générés
par chaque Entreprise Extérieure<br>
Les réunions se font à l’initiative de l’Entreprise Utilisatrice, avec information à tous les partenaires
sociaux internes, CSE, ou externes, médecine du Travail.<br>
Le Plan de Prévention Evolutif précise les mesures à prendre par chaque entreprise pour supprimer ces
risques, les diminuer ou les limiter à un niveau acceptable.<br>
Un Plan de Prévention Évolutif, doit être élaboré avec toutes les EE œuvrant sur une opération spécifique
à l’intérieur d’un même pôle. Il peut aussi être élaborer avec toutes les EE rassemblant tous les secteurs
d’activité d’un même pôle ou avec toutes les EE rassemblant un seul secteur d’activité d’un même pôle.
Le chef de l’Entreprise Utilisatrice a une obligation générale de coordination et de
surveillance de l’Opération. Il doit alerter le chef de l’Entreprise Extérieure s’il constate un
risque ou un manquement aux obligations de sécurité, même si ce risque n’est pas lié à
l’interférence entre plusieurs activités.<br>
Le chef d’une Entreprise Extérieure est tenu quant à lui de rappeler au chef de l’Entreprise Utilisatrice la
coordination que celui-ci doit assurer, si par exemple les « Visites d’Inspection Préalable » des lieux de
travail ne sont pas effectuées ou si le « Plan de Prévention Evolutif » n’a pas été élaboré précisément
pour l’opération concernée et avant toute intervention, puis mis à jour au fur et à mesure de l’arrivée de
chaque Entreprise Extérieure

`;*/
          swal({
            html:true,
            content: span,
              title: 'Un PLAN de PREVENTION / Evolutif pour quoi faire ?',
              
              type: 'warning',
              className: 'help_dialog',
              buttons: {
                    confirm: {text:"OK", className:"btn btn-default"},
              },
            })
        },
        

    },


  }
</script>
<style>

</style>
